import httpClient from './httpClient';

const getCompany = (id) => httpClient.get(`/companies/${id}`);

export { getCompany };
